import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './SectionDivider.module.scss';

type Props = {
  classes?: string;
};

function SectionDivider({ children, classes }: PropsWithChildren<Props>) {
  return (
    <div {...setDenaliAttribute('SectionDivider')} className={classNames(styles.wrapper, classes)}>
      <span className={styles.line} />
      {children && <span className={styles.text}>{children}</span>}
      <span className={styles.line} />
    </div>
  );
}

export default SectionDivider;
